// extracted by mini-css-extract-plugin
module.exports = {"card":"card--WtA-R","cardWrapper":"cardWrapper--Ccwyb","icon":"icon--wCvAY"};